import { BaseBonusModel } from "../../bonusModels/baseBonusModel";
export class BonusAmountGetRequestModel extends BaseBonusModel {};